import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('confirm-modal')
export class ConfirmModal extends LitElement {
    static amplitude_callsite: string = 'Confirm Modal';

    @property({ type: String })
    heading?: string = 'Confirm';

    @property({ type: String })
    content?: string = 'Are you sure?';

    @property({ type: String })
    cancelButtonText?: string = 'Cancel';

    @property({ type: String })
    submitButtonText?: string = 'Confirm';

    private async handleSubmit() {
        this.dispatchEvent(new CustomEvent('confirm'));
    }

    private async handleCancel() {
        this.dispatchEvent(new CustomEvent('close'));
    }

    render() {
        return html`
            <div class="folderModalContent">
                <h2 id="modalTitle">${this.heading}</h2>
                <p>${this.content}</p>
                <div class="actionButtonsWrapper">
                    <form-button variant="social" @click="${this.handleCancel}">
                        ${this.cancelButtonText}
                    </form-button>
                    <form-button class="form-btn" @click="${this.handleSubmit}">
                        ${this.submitButtonText}
                    </form-button>
                </div>
                <error-toast id="errorToast"></error-toast>
                <div></div>
            </div>
        `;
    }

    static get styles() {
        return css`
            .folderModalContent {
                padding: 0.5rem 1.5rem 1rem;
            }

            #modalTitle {
                margin-bottom: 1.25rem;
                color: var(--main-primary-color);
                display: flex;
                algin-items: center;
                justify-content: center;
            }

            .actionButtonsWrapper {
                margin-top: 1.5rem;
                display: flex;
                justify-content: center;
            }

            form-button {
                padding: 0.5rem;
            }
        `;
    }
}
